import cx from "classnames";

import ArrowDownIcon from "./assets/arrow-down.svg?react";
import styles from "./ScrollToBottomButton.module.css";

type ScrollToBottomButtonProps = {
  visible: boolean;
  onClick: () => void;
};

export const ScrollToBottomButton = ({
  visible,
  onClick,
}: ScrollToBottomButtonProps) => (
  <div className={cx(styles.root, visible && styles.visible)}>
    <button
      className={styles.button}
      onClick={onClick}
      onPointerDown={(e) => e.preventDefault()}
      aria-label="Scroll to bottom"
      type="button"
    >
      <ArrowDownIcon width={16} height={16} />
    </button>
  </div>
);
